import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { TenantAuthClaims } from '@models';
import { catchError, first, from, map, of, switchMap } from 'rxjs';

export function loginGuard(): CanActivateFn {
  return () => {
    const auth = inject(Auth);
    const router = inject(Router);

    return authState(auth).pipe(
      first(),
      catchError(() => of(null)),
      switchMap((user) => {
        if (!user) return of(true);
        // Read JWT claims to redirect SUPER_ADMIN to /platform, others to /dashboard
        return from(user.getIdTokenResult()).pipe(
          map((tokenResult) => {
            const claims = tokenResult.claims as unknown as TenantAuthClaims;
            if (claims?.superAdmin === true) {
              return router.createUrlTree(['/platform']);
            }
            return router.createUrlTree(['/dashboard']);
          }),
          catchError(() => of(router.createUrlTree(['/dashboard']))),
        );
      }),
    );
  };
}
